import { observable, action, useStrict, runInAction, autorun, flow, set, toJS } from 'mobx';
import {
  isEmpty,
  isArray,
  cloneDeep,
  filter,
  merge,
  get,
  includes,
  has,
  pick,
  isUndefined,
  isNull
} from 'lodash';
import { Toast } from 'antd-mobile';
import Serv from './ProfitSharBindServ';

const shopListParams = {
  cityCode: '', //	string  城市编码
  code: '', //	string  店铺编号
  countyCode: '', //	string  区编码
  pageNum: 1, //	number  页码
  pageSize: 4, //	number 每页数量
  provinceCode: '', //	string  省份编码
  area: [],
  // 类型 1：店铺，2：会员
  type: 1
};
class ProfitSharBindMod {
  @observable shopList = [];

  @observable total = 0;

  @observable shopListParams = { ...shopListParams };

  @observable loadStatus = 'loading'; // 状态 more:上拉加载更多   loading:加载中   noMore:没有更多了

  @action
  changeShopListParams(key, val) {
    this.shopListParams[key] = val;
    if (key == 'area') {
      let provinceCode = '',
        cityCode = '',
        countyCode = '';
      if (val.length > 0) {
        provinceCode = val[0] ? val[0].value : '';
        cityCode = val[1] ? val[1].value : '';
        countyCode = val[2] ? val[2].value : '';
      }
      this.shopListParams['provinceCode'] = provinceCode;
      this.shopListParams['cityCode'] = cityCode;
      this.shopListParams['countyCode'] = countyCode;
    }
  }

  @action
  resetshopList() {
    this.shopList = [];
  }

  @action
  toReset() {
    this.shopListParams = { ...shopListParams };
    //this.toSearch()
  }
  @action
  toSearch(type) {
    const params = toJS(this.shopListParams);
    if (params.area.length == 0 && !params.code) {
      return;
    }
    delete params.area;
    this.queryMutualBenefitShopList(params, type);
  }

  //获取店铺列表
  queryMutualBenefitShopList = flow(function* (params, type) {
    try {
      this.loadStatus = 'loading';
      const res = yield Serv.queryMutualBenefitShopList(params);
      if (res.resultCode == '0') {
        if (type == 'more') {
          this.shopList = [...toJS(this.shopList), ...res.data.list];
        } else {
          this.shopList = res.data.list || [];
        }
        this.total = res.data.total;
        this.shopListParams.pageNum += 1;
        if (this.shopList.length >= this.total) {
          this.loadStatus = 'noMore';
        } else {
          this.loadStatus = 'more';
        }
      }
    } catch (error) {}
  });

  //申请绑定
  applyBindingShop = flow(function* (shopCode) {
    try {
      return yield Serv.applyBindingShop(shopCode, this.shopListParams.type);
    } catch (error) {
      return null;
    }
  });
}
const profitSharBindMod = new ProfitSharBindMod();
export default profitSharBindMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/ProfitSharing/ProfitSharBind/ProfitSharBindMod.js